import Cookies from 'js-cookie';

/**
 * Set the coupon banner height as a CSS custom property.
 *
 * @param {number} height The height in pixels.
 * @return {void}
 */
const setCouponBannerHeight = (height) => {
    document.documentElement.style.setProperty('--coupon-banner-height', `${height}px`);
};

let isClose = Cookies.get('psmweb__couponBar_2plus2_closed');

const topbar = document.getElementById('js-topbar');
const body = document.getElementsByTagName('body')[0];

if (!isClose && topbar) {
    topbar.classList.add('!translate-y-0');

    const topbarHeight = topbar.offsetHeight;
    setCouponBannerHeight(topbarHeight);

    document.getElementById('js-topbar-close').addEventListener('click', function() {
        Cookies.set('psmweb__couponBar_2plus2_closed', true);
        topbar.classList.remove('!translate-y-0');
        setCouponBannerHeight(0);
    });
} else {
    setCouponBannerHeight(0);
}
